import { render, staticRenderFns } from "./CheckboxDefault.vue?vue&type=template&id=ea88b11a&"
import script from "./CheckboxDefault.vue?vue&type=script&lang=js&"
export * from "./CheckboxDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports